import * as React from 'react';
import { PersonCardData } from '../types';

type Props = {
  data: PersonCardData;
};

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

const PersonCardWidget: React.FC<React.PropsWithChildren<Props>> = ({
  data,
}) => (
  <div className="ai-chat-widget ai-chat-widget-person">
    <div className="ai-chat-widget-person-avatar">
      {data.avatarUrl ? (
        <img src={data.avatarUrl} alt={data.name} />
      ) : (
        <span className="ai-chat-widget-person-avatar-initials">
          {getInitials(data.name)}
        </span>
      )}
    </div>
    <div className="ai-chat-widget-person-meta">
      <span className="ai-chat-widget-person-name">{data.name}</span>
      {data.role && (
        <span className="ai-chat-widget-person-role">{data.role}</span>
      )}
    </div>
  </div>
);

export default PersonCardWidget;
